import SvgIcon from '../components/common/SvgIcon.vue'
import Alert from '../components/common/Alert.vue'
import NumberSelector from '../components/common/NumberSelector.vue'
import Pagination from '../components/common/Pagination.vue'
import Table from '../components/common/Table.vue'
import Tooltip from '../components/common/Tooltip.vue'
import LanguageSwitcher from '../components/common/LanguageSwitcher.vue'
import DetailBox from '../components/common/DetailBox.vue'

import { MDBModal, 
    MDBModalHeader, 
    MDBModalBody, 
    MDBModalTitle, 
    MDBModalFooter, 
    MDBBtn,
    MDBDropdown,
    MDBDropdownMenu,
    MDBDropdownItem,
    MDBDropdownToggle,
 } from 'mdb-vue-ui-kit';
export default {
  install(app) {
    // 注册自定义全局组件
    app.component('SvgIcon', SvgIcon)
    app.component('Alert', Alert)
    app.component('NumberSelector', NumberSelector)
    app.component('Pagination', Pagination)
    app.component('Table', Table)
    app.component('Tooltip', Tooltip)
    app.component('LanguageSwitcher', LanguageSwitcher)
    app.component('DetailBox', DetailBox);

      [ MDBModal, 
        MDBModalHeader, 
        MDBModalBody, 
        MDBModalTitle,
        MDBModalFooter,
        MDBBtn,
        MDBDropdown,
        MDBDropdownMenu,
        MDBDropdownItem,
        MDBDropdownToggle
    ].forEach(component => {
        app.component(component.name, component)
    })
  }
} 